import React from 'react';
import { Link } from 'react-router-dom';

export default function MainMenu() {
  return (
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/articles">Articles</Link></li>
        <li><Link to="/about">About</Link></li>
      </ul>
  );
}
